import {defineStore} from 'pinia'

export const useBookingInputStore = defineStore('bookingInput', {
    state: () => ({
        zone: undefined as number | undefined,
        freqRange: undefined as string | undefined,
        freqRange2: undefined as string | undefined,
        band: undefined as string | undefined,
        band2: undefined as string | undefined,
        channel: undefined as string | undefined,
        channel2: undefined as string | undefined,
        pilot: undefined as number | undefined,
        withRepeater: undefined as boolean | undefined,
        repeaterChannel: undefined as string | undefined,
        secondChannelInUse: undefined as boolean | undefined,
        comment: undefined as string | undefined,
        direction: undefined as Ref<{text: string, value: string, coordinates?: string, direction: string}> | string | undefined,
        missionType: 'radio' as 'radio' | 'digital' | 'bomber',
        connectionType: undefined as 'optic' | 'starlink' | 'lte' | 'ocusync' | 'nakande' | 'unknown' | undefined,
        activeMissionType: undefined as 'radio' | 'digital' | 'bomber' | undefined,
        controlFrequency: undefined as {
            type: string,
            firstFrequency: number | null,
            secondFrequency: number | null,
            valid: boolean
        } | undefined,
        freq: undefined as {
            type: string,
            firstFrequency: number | null,
            secondFrequency: number | null,
            valid: boolean
        } | undefined
    }),
    getters: {
        isFormChanged: (state: any): boolean => {
            return Boolean(state?.pilot ||  state?.band ||  state?.channel ||
                state?.freqRange ||  state?.freqRange2 ||  state?.band2 ||  state?.channel ||
                state?.withRepeater ||  state?.repeaterChannel ||
                state?.controlFrequency || state?.secondChannelInUse)
        }
    }
})